import React, { useEffect, useRef, useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NumberPagination from "../../Pagination";
import SideMenu from "../../Components/SideMenu";
import {
  uploadListFileInChat,
} from "../../reducers/commonReducer";
import moment from "moment";
import { uploadedFiles, users } from "../../const";
import ShowImage from "../../Components/ShowImage";

const UploadedFiles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const width = useRef(window.innerWidth);
  const queryParameters = new URLSearchParams(window.location.search);
  const userId = queryParameters.get("id");
  const pagenumber = queryParameters.get("page");
  const [page, setPage] = useState(Number(pagenumber) || 1);
  useEffect(() => {
    dispatch(uploadListFileInChat({
      uploadedBy: userId,
      page,
    }));
  }, [dispatch, page, userId]);

  const { uploadFileInChatList, uploadFileInChatListPage } =
    useSelector((state) => state.commonReducer);
  const onPageChange = (number) => {
    setPage(number);
  };

  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        {/* <Row className="justify-content-end">
          <Col md={1}>
            <Button
              variant="danger"
              onClick={() => {
                navigate(users);
                window.location.reload();
              }}
            >
              Clear
            </Button>
          </Col>
        </Row> */}
        <Row className="no-more-tables no-more-tables-font">
          <table className={width.current > 500 ? "table w-100" : null}>
            <thead>
              <tr className="tables">
                <th>Sr</th>
                <th>Image</th>
                <th>Date</th>
                <th>UploadedBy</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody className="tbody-table">
              {!!uploadFileInChatList &&
                uploadFileInChatList?.map((item, index) => {
                  return (
                    <tr key={index} className="mbl-table-card">
                      <td data-title="Sr.">{index + 1}</td>
                      <td data-title="Image">
                        {/* <img
                          className="max-width"
                          src={`${item?.cloudUrl}`}
                          alt={item?.fileName}
                        /> */}
                        <ShowImage img={item?.cloudUrl} alt={item?.fileName} width={"max-width"}/>
                      </td>
                      <td data-title="Date">
                      {moment(item?.createdAt).format("DD/MM/YY")}
                      </td>
                      <td data-title="UploadedBy">{`${item?.uploadedBy?.firstName} ${item?.uploadedBy?.lastName}`}</td>
                      <td data-title="Phone">{item?.uploadedBy?.phone}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Row>
        <Row className="mt-3">
          <Col>
            <NumberPagination
              pageCount={uploadFileInChatListPage}
              currentPage={page}
              api={uploadListFileInChat}
              onPageChange={onPageChange}
              pageurl={uploadedFiles}
              filters={{ id: userId }}
              shouldDispatch={false}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UploadedFiles;
